import Button from "@mui/material/Button";
import clsx from "clsx";

type FilterButtonProps = Readonly<{
	label: string;
	isDisabled: boolean;
	selected: boolean;
	vehicleAmount: number;
	onToggleSelected: () => void;
}>;

export default function FilterButtonReconciliation(props: FilterButtonProps) {
	const { label, isDisabled, selected, vehicleAmount, onToggleSelected } = props;

	return (
		<Button
			variant="outlined"
			disabled={isDisabled}
			onClick={onToggleSelected} // Let the parent handle toggling & filtering
			classes={{
				root: clsx({
					"h-[30px] !rounded-md !normal-case ": true,
					"!border-disabled": !selected,
					"!border-primary !shadow-lg": selected,
				}),
				outlined: clsx({
					"!font-montserrat !text-xs !text-default !font-medium": true,
					"!text-[#808080]": !selected && !isDisabled,
				}),
				disabled: clsx({
					"!bg-disabled !text-white !outline-white": true,
					"!border-none": isDisabled,
				}),
			}}
		>
			{label} {vehicleAmount > 0 && `(${vehicleAmount})`}
		</Button>
	);
}
